import { PagingRequest } from '@/types/http';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: classNames.ArgumentArray) {
    return twMerge(classNames(inputs));
}

export function getAvatarFallbackName(fullname?: string) {
    if (!fullname) return '';
    const names = fullname.trim().split(' ');

    if (names.length === 1) {
        // Trường hợp chỉ có một từ
        return `${names[0].charAt(0).toUpperCase()}${names[0].charAt(1).toUpperCase()}`;
    } else if (names.length > 1) {
        // Lấy ký tự đầu tiên của tên và họ
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }

    return '';
}

export function haversineDistance(location1: [number, number], location2: [number, number]): number {
    const R = 6371000; // Bán kính Trái Đất (m)
    const toRad = (angle: number) => (angle * Math.PI) / 180;

    const dLat = toRad(location2[1] - location1[1]);
    const dLon = toRad(location2[0] - location1[0]);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(location1[1])) * Math.cos(toRad(location2[1])) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Khoảng cách tính bằng m
}

export function handleLongText(text: string, numAccept: number): string {
    let finalText = text;
    const length = text.length;
    if (length <= numAccept * 2) return text;
    const head = text.slice(0, numAccept);
    const indexDomain = text.lastIndexOf('@');
    let foot = text.slice(indexDomain - numAccept, length);
    if (foot.length >= 25) {
        const temp = foot;
        const indexDot = temp.lastIndexOf('.');
        foot = temp.slice(indexDot - numAccept, temp.length);
    }
    finalText = head + ' ... ' + foot;
    return finalText;
}

export function getParamsLoadMore(currentParams: PagingRequest, total: number): PagingRequest | null {
    const crrSize = currentParams.size;
    if (crrSize === total || total === 0) {
        return null;
    } else if (crrSize + 10 > total) {
        return { ...currentParams, size: total };
    } else {
        return { ...currentParams, size: crrSize + 10 };
    }
}

export function generateCouponCode() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let couponCode = '';
    const timestamp = Date.now();

    for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        couponCode += chars[randomIndex];
    }

    return `${timestamp}${couponCode}`;
}
